<template>
  <view class="ad-item-container" bindtap="goPage">
    <view class="left">
      <view class="title">{{config.title}}</view>
      <view class="subtitle">{{config.subtitle}}</view>
      <view class="btn">
        <view class="btn-text">{{config.btnText}}</view>
        <image class="arrow" src="{{arrowRight}}"/>
      </view>
    </view>
    <view class="right">
      <image class="icon" src="{{config.icon}}" mode="widthFix" />
    </view>
  </view>
</template>

<script>
  import { createComponent, mpx } from '@didi/es-mpx-creator'
  import { innerRouter, pagePath } from '@/common/jump'
  import { trackEvent } from '@/common/track'
  import { isDdPassengerH5 } from '@/common/constant'
  import { getStorage } from '@/utils/storage'
  createComponent({
    props: {
      config: {
        type: Object,
        value: {}
      },
      index: String
    },
    data: {
      arrowRight: 'https://ut-static.udache.com/webx/sfc/0qbanERtu9oZBz5eDCKML_arrowright.png'
    },
    computed: {
      url(){
        return isDdPassengerH5 ? this.config?.toUrl : this.config?.toUrlMiniH5 
      }
    },
    methods: {
      goPage() {
        trackEvent('userteam_train_home_secbanner_ck', 'UT-火车票-首页-副banner-点击', {
          index: this.index,
          to_url: this.url
        })
        innerRouter.goTo(this.url,{
          token: getStorage('token') || getStorage('userInfo')?.token
        })
      }
    },
    watch: {}
  })
</script>

<style lang="stylus" scoped>
  .ad-item-container
    width 350px
    height 72px
    display flex
    flex-direction row
    padding 12px 16px 14px 16px
    box-sizing border-box
    justify-content space-between
    .left
      .title
        font-family PingFangSC-Medium
        font-size 13px
        font-weight normal
        line-height 16px
        letter-spacing 0px
        color #000000
      .subtitle
        font-family PingFangSC-Regular
        font-size 10px
        font-weight normal
        line-height 12px
        letter-spacing 0px
        color #888888
        margin 2px 0 4px
      .btn
        display flex
        flex-direction row
        align-items center
        .btn-text
          font-family PingFangSC-Semibold
          font-size 11px
          font-weight normal
          line-height 13px
          letter-spacing 0px
          color #E5723A
          margin-right 3px
        .arrow
          width 5px
          height 7px
    .right
      display flex
      align-items center
      .icon
        width 48px
        height 40px
</style>

<script name="json">
  module.exports = {
    component: true
  }
</script>
